import LinearProgress from '@mui/joy/LinearProgress';
import JoyTypography from '@mui/joy/Typography';

type ProgressBarProps = {
  /** Preenchimento de 0 a 100. */
  value: number;
  /** Texto exibido dentro da barra. */
  label: string;
  maxWidth?: number;
};

/** Barra horizontal com o texto por cima, usada para Score e Quantidade/Meta. */
export function ProgressBar({ value, label, maxWidth }: ProgressBarProps) {
  return (
    <LinearProgress
      determinate
      variant="outlined"
      color="neutral"
      size="sm"
      thickness={32}
      value={value}
      sx={{
        '--LinearProgress-radius': '0px',
        boxShadow: 'sm',
        borderColor: 'neutral.500',
        background: 'white',
        ...(maxWidth !== undefined && { maxWidth }),
      }}
    >
      <JoyTypography
        level="body-xs"
        textColor="common.white"
        sx={{ fontWeight: 'xl', mixBlendMode: 'difference' }}
      >
        {label}
      </JoyTypography>
    </LinearProgress>
  );
}
